<template>
  <div>
    <el-row :gutter="20">
      <i class="el-tag el-tag--success el-tag--mini" style="cursor: pointer;" @click.prevent="addRule">添加</i>
    </el-row>
    <el-row :gutter="20">
      <div class="rule-group-box flex-row">
        <el-table border
                  show-overflow
                  ref="xTable"
                  height="calc(20vh)"
                  :data="tableData">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="querykey" min-width="160" label="条件字段" >
            <template slot-scope="scope">
              <span>
                <el-input size="small" v-model="scope.row.querykey" @input="val=>{ return inputword(val,scope.$index,'querykey')}"></el-input>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="relation" min-width="160" label="关系符" v-if="isRelation" >
            <template slot-scope="scope">
              <span>
                <select-type :isEdit="true"  typeId="SYS_FieldRelation" v-model="scope.row.relation" @input="selinput(scope.row.relation)" placeholder="请选择"></select-type>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="modelkey" min-width="160" label="当前页面字段">
            <template slot-scope="scope">
                <el-input size="small" v-model="scope.row.modelkey" @input="val=>{ return inputword(val,scope.$index,'modelkey')}"></el-input>
            </template>
          </el-table-column>
          <el-table-column min-width="60px" :label="'操作'" align="center">
            <template slot-scope="scope">
              <span>
                <i class="el-tag el-tag--danger el-tag--mini" style="cursor: pointer;" @click.prevent="deleteItem(scope.$index)">删除</i>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import SelectType from '@/components/SelectType';

export default {
  name: 'group-item',
  components: {
    SelectType
  },
  props: {
    formData: {
      type: Array,
      default() {
        return [{
          querykey: '',
          relation: '',
          modelkey: ''
        }];
      }
    },
    isRelation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableData: []
    };
  },
  created() {
    this.InitData();
  },
  watch: {
    formData(val) {
      this.InitData();
    }
  },
  methods: {
    inputword(val, index, key) {
      let valtemp = val.trim();
      valtemp = valtemp.substring(0, 1).toLowerCase() + valtemp.substring(1);
      this.tableData[index][key] = valtemp;
      this.postdata();
    },
    InitData() {
      this.tableData = [];
      this.formData.filter(item => {
        return item.querykey !== '' || item.modelkey !== '' || item.relation !== '';
      }
      ).forEach(item => {
        const tempObj = {
          querykey: item.querykey,
          modelkey: item.modelkey
        };
        if (this.isRelation) {
          tempObj.relation = item.relation ? item.relation : '==';
        }
        this.tableData.push(tempObj);
      });
    },
    deleteItem(index) {
      this.tableData.splice(index, 1);
      this.postdata();
    },
    addRule() {
      const tempObj = {
        querykey: '',
        modelkey: ''
      };
      if (this.isRelation) {
        tempObj.relation = '==';
      }
      this.tableData.push(tempObj);
    },
    selinput(val) {
      this.postdata();
    },
    postdata() {
      console.log(this.tableData);
      this.$emit('update:formData', this.tableData);
    }
  }
};
</script>
<style>
</style>
